export interface ToastData {
    type: 'success' | 'error';
    text: string;
    duration?: number;
}

export class ToastDataHelper {
    static default(): ToastData {
        return {
            type: 'success',
            text: '',
            duration: 5000,
        };
    }

    static create(data: any) {
        const d = ToastDataHelper.default();
        return { ...d, ...data };
    }
}
